import { render, staticRenderFns } from "./craftsmanManage.vue?vue&type=template&id=31335cbb&scoped=true"
import script from "./craftsmanManage.vue?vue&type=script&lang=js"
export * from "./craftsmanManage.vue?vue&type=script&lang=js"
import style0 from "./craftsmanManage.vue?vue&type=style&index=0&id=31335cbb&prod&lang=less&scoped=true"
import style1 from "./craftsmanManage.vue?vue&type=style&index=1&id=31335cbb&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31335cbb",
  null
  
)

export default component.exports